import { render, staticRenderFns } from "./GrandeSection.vue?vue&type=template&id=0e4569c0&scoped=true"
import script from "./GrandeSection.vue?vue&type=script&lang=js"
export * from "./GrandeSection.vue?vue&type=script&lang=js"
import style0 from "./GrandeSection.vue?vue&type=style&index=0&id=0e4569c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4569c0",
  null
  
)

export default component.exports